<template>
  <FourElements />
  <div style="background: #fff; margin-top: 20px; ">
    <div class="p20" style="max-width: 1000px;">
      <a-form>
        <h3>统计配置</h3>
        <a-form-item label="计算周期">
          <a-input readonly :value="45" addon-after="天" style="width: 160px" />
        </a-form-item>
        <a-form-item label="退货周期">
          <a-input
            readonly
            :value="365"
            addon-after="天"
            style="width: 160px"
          />
        </a-form-item>
        <h3 style="margin-top: 30px;">定级配置</h3>
        <a-row :gutter="16" style="line-height: 32px;">
          <a-col :span="8"></a-col>
          <a-col :span="4">shore</a-col>
          <a-col :span="4">sand</a-col>
          <a-col :span="4">sea</a-col>
          <a-col :span="4">sun</a-col>
          <a-col :span="8">当前等级订单数量阈值</a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[0].orderQuantity"
              disabled
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[1].orderQuantity"
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[2].orderQuantity"
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[3].orderQuantity"
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4" style="text-align: center;">OR</a-col>
          <a-col :span="20" style="text-align: center;"></a-col>
          <a-col :span="8">当前等级订单金额阈值</a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[0].orderAmount"
              disabled
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[1].orderAmount"
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[2].orderAmount"
              style="width: 100%"
            ></a-input-number>
          </a-col>
          <a-col :span="4">
            <a-input-number
              v-model:value="initState.userLevels[3].orderAmount"
              style="width: 100%"
            ></a-input-number>
          </a-col>
        </a-row>
        <h3 style="margin-top: 30px;">GO链接配置</h3>
        web:
        <a-input
          placeholder="请输入"
          style="width: 100%"
          :maxlength="200"
          v-model:value="initState.webUrl"
        ></a-input>
        app:
        <a-input
          placeholder="请输入"
          style="width: 100%"
          :maxlength="200"
          v-model:value="initState.appUrl"
        ></a-input>
        <h3 style="margin-top: 30px;">规则文案配置</h3>
        <a-tabs v-model:activeKey="initState.currentLang" size="small">
          <a-tab-pane
            v-for="lang in initState.langList"
            :key="lang.value"
            :tab="lang.label"
          />
        </a-tabs>
        <a-textarea
          v-if="currentRule"
          v-model:value="currentRule.ruleContent"
          style="height: 100px;"
          placeholder="请输入"
          :maxlength="2000"
          :auto-size="false"
        />
        <!-- <a-textarea
          v-model:value="initState.rule"
        ></a-textarea> -->
      </a-form>
      <a-button type="primary" style="margin-top: 20px;" @click="save"
        >保存</a-button
      >
    </div>
  </div>
</template>

<script setup>
import { reactive, provide, onMounted, computed, watch } from 'vue'
import FourElements from './components/FourElements'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash'
import {
  common_querySiteInfo_get,
  common_lang_get
} from '@/server/modules/3426'
import {
  userSystem_detail_get,
  userSystem_save_post
} from '@/server/modules/50906'

const route = useRoute()
const { brandId, channelId, siteId } = route.query

const defaultUserLevels = [
  {
    levelCode: 1,
    orderAmount: 0,
    orderQuantity: 0
  },
  {
    levelCode: 2,
    orderAmount: 0,
    orderQuantity: 0
  },
  {
    levelCode: 3,
    orderAmount: 0,
    orderQuantity: 0
  },
  {
    levelCode: 4,
    orderAmount: 0,
    orderQuantity: 0
  }
]

const initState = reactive({
  searchParams: {
    brandId: brandId ? +brandId : 1,
    channelId: channelId ? +channelId : 1,
    siteId: siteId ? +siteId : 1
  },
  userSystemId: null,
  brands: [],
  channels: [],
  sites: [],
  terminals: [],
  langList: [],
  currentLang: '',
  webUrl: '',
  appUrl: '',
  userLevels: defaultUserLevels,
  ruleContents: [],
  initList: async () => {
    await getSiteLang()
    const params = {
      ...initState.searchParams
    }
    const { data } = await userSystem_detail_get(params)
    if (data) {
      initState.userSystemId = data.userSystemId
      initState.userLevels = data.userLevels
      initState.ruleContents = initState.langList.map(l => ({
        langCode: l.value,
        ruleContent: ''
      }))
      data.ruleContents?.forEach(element => {
        const l = initState.ruleContents.find(
          i => i.langCode === element.langCode
        )
        if (l) l.ruleContent = element.ruleContent
      })
      initState.webUrl = data.webUrl
      initState.appUrl = data.appUrl
    } else {
      initState.userSystemId = null
      initState.userLevels = cloneDeep(defaultUserLevels)
      initState.webUrl = ''
      initState.appUrl = ''
    }
  }
})

const currentRule = computed(() => {
  return initState.ruleContents.find(i => i.langCode === initState.currentLang)
})

provide('initState', initState)

const getSiteLang = async () => {
  const { success, data, retInfo } = await common_lang_get(
    initState.searchParams
  )
  if (success) {
    initState.langList = Object.entries(data.languageMap).map(
      ([key, value]) => ({
        label: key,
        value: value
      })
    )
    initState.currentLang = data.defaultLanguageCode
    initState.ruleContents = initState.langList.map(l => ({
      langCode: l.value,
      ruleContent: ''
    }))
  } else {
    message.error(retInfo)
  }
}

const save = async () => {
  if (!initState.webUrl) {
    return message.error('请输入PC按钮跳转地址')
  }
  if (!initState.appUrl) {
    return message.error('请输入APP按钮跳转地址')
  }
  if (initState.ruleContents.some(i => !i.ruleContent)) {
    return message.error('请填写规则文案')
  }
  for (let i = 0; i < initState.userLevels.length; i++) {
    if (i < initState.userLevels.length - 1) {
      if (
        initState.userLevels[i].orderAmount >=
        initState.userLevels[i + 1].orderAmount
      ) {
        message.error('每个等级订单金额阈值不能大于等于下一等级')
        return
      }
      if (
        initState.userLevels[i].orderQuantity >=
        initState.userLevels[i + 1].orderQuantity
      ) {
        message.error('每个等级订单数量阈值不能大于等于下一等级')
        return
      }
    }
  }
  const params = {
    ...initState.searchParams,
    userSystemId: initState.userSystemId,
    webUrl: initState.webUrl,
    appUrl: initState.appUrl,
    userLevels: initState.userLevels,
    ruleContents: initState.ruleContents
  }
  const { success } = await userSystem_save_post(params)
  if (success) {
    message.success('保存成功')
  }
}

watch(
  () => initState.searchParams,
  () => {
    initState.initList()
  },
  { deep: true }
)

onMounted(async () => {
  const { data } = await common_querySiteInfo_get()
  initState.brands = data['1']
  initState.channels = data['2']
  initState.sites = data['3']
  initState.initList()
})
</script>
